import { render, staticRenderFns } from "./Organization.vue?vue&type=template&id=046a4471&scoped=true"
import script from "./Organization.vue?vue&type=script&lang=ts"
export * from "./Organization.vue?vue&type=script&lang=ts"
import style0 from "./Organization.vue?vue&type=style&index=0&id=046a4471&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046a4471",
  null
  
)

export default component.exports